import React, { Component } from "react";
import { Spin } from "antd";

export default class Loding extends Component {
  render() {
    return (
      <div
        style={{
          display: this.props.isLoading ? "block" : "none",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999
        }}
      >
        <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
          <Spin tip="Loading..." />
        </div>
      </div>
    );
  }
}
